import React, { useState, useEffect, useRef } from 'react';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import AmsaleAcc from '../../../../assets/images/Amsale-Acc.webp';
import AmsaleDresses from '../../../../assets/images/Amsale-Dresses.webp';
import AmsaleBespokeBridal from '../../../../assets/images/Amsale-Bespoke-Bridal.webp';
import AmsaleFeb from '../../../../assets/images/Amsale-february.webp';
import AmsaleBespokeBM from '../../../../assets/images/Amsale-Bespoke-BM.webp';
import AmsaleBM from '../../../../assets/images/Amsale-BM.webp';
import AmsaleBridal from '../../../../assets/images/Amsale-Bridal.webp';
import AmsaleFlagShipAppt from '../../../../assets/images/Amsale-Flagship-Appt.webp';
import AmsaleLWD from '../../../../assets/images/Amsale-LWD.webp';
import AmsaleMOTGB from '../../../../assets/images/Amsale-MOTGB.webp';
import AmsaleNouvelleBridal from '../../../../assets/images/Amsale-Nouvelle-Bridal.webp';
import AmsaleNouvelleBM from '../../../../assets/images/Amsale-Nouvelle-BM.webp';
import AmsaleVRAppt from '../../../../assets/images/Amsale-VR-Appt.webp';
import AmsaleWGE from '../../../../assets/images/Amsale-WGE.webp';


function DesktopMainNav({ mainMenu, klassName }) {
  const { makeStyles } = useUiContext();
  const [image, setImage] = useState(AmsaleDresses);
  const submenuCache = useRef({});
  const submenuTimer = useRef(null);


  const useStyles = makeStyles((theme) => ({
    container: {
      display: 'grid !important',
      gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
      gridGap: '20px',
      height: '550px',
      width: '100%',
      alignItems: 'start',
    },
    column: {
      padding: theme.spacing(0),
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      opacity: 1,
      width: 'auto',
      height: 'auto',
      transition: '0.3s ease-in-out',
    },
    actualImage: {
      height: 'auto',
      maxHeight: '375px',
      width: 'auto',
      display: 'flex',
      aspectRatio: '4 / 5',
      [theme.breakpoints.up('xl')]: {
        maxHeight: '500px',
      },
    },
    categoryContainer: {
      marginBottom: '10px',
    },
    categoryLink: {
      fontSize: '0.875rem!important',
      fontWeight: 'bold',
    },
    subCategoryContainer: {
      fontWeight: 'bold',
      marginBottom: '10px',
    },
    featSubCatContainer: {
      marginTop: '35px',
      fontWeight: 'bold',
      marginBottom: '10px',
    },
    subnavLink: {
      fontWeight: 'normal',
      marginBottom: '10px',
    },
    aboutLink: {
      marginBottom: '10px',
    },
  }));

  const styles = useStyles();

  const stringParameterize = function (str1) {
    return str1.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, '').replace(/\s/g, '-');
  };

  const getSubmenu = (id) => {
    if (!submenuCache.current[id]) {
      submenuCache.current[id] = document.getElementById(id);
    }
    return submenuCache.current[id];
  };

  const handleMouseEnter = (event) => {
    const submenuId = event.target.getAttribute('aria-controls');
    const submenu = getSubmenu(submenuId);
    if (submenu && klassName === 'right-menu') {
      const linkRect = event.target.getBoundingClientRect();
      clearTimeout(submenuTimer.current);
      submenu.style.height = '300px';
      const submenuList = submenu.querySelector('ul.main-submenu');
      if (submenuList) {
        submenuList.style.position = 'absolute';
        submenuList.style.left = `${linkRect.left}px`;
      }
    }
  };

  const chunkItems = (items, parent) => {
    if (parent !== 'Shop') {
      return items;
    }

    const chunkedItems = [[], [], [], []];
    chunkedItems[0].push(items[0], items[1]);
    chunkedItems[1].push(items[2]);
    chunkedItems[2].push(items[3]);
    chunkedItems[3].push(items[4]);
    return chunkedItems;
  };

  const imageMap = new Map([
    [['Ready-to-Wear', 'Dresses', 'Featured', 'New In: RTW 25'], AmsaleDresses],
    [['Mother of the Bride/Groom'], AmsaleMOTGB],
    [['Wedding Guest Edit'], AmsaleWGE],
    [['The February Edit'], AmsaleFeb],
    [['Weddings', 'Bridal', 'AMSALE'], AmsaleBridal],
    [['Nouvelle Amsale'], AmsaleNouvelleBridal],
    [['Little White Dress'], AmsaleLWD],
    [['Accessories'], AmsaleAcc],
    [['Bridesmaids', 'Amsale'], AmsaleBM],
    [['Nouvelle Amsale', 'Swatches'], AmsaleNouvelleBM],
    [['Bespoke', 'Amsale x You Bridal'], AmsaleBespokeBridal],
    [['Amsale x You Bridesmaids'], AmsaleBespokeBM],
    [['Styling', 'Flagship Appointment'], AmsaleFlagShipAppt],
    [['Virtual Appointment', 'Trunk Shows', 'Alterations', 'Store Locator'], AmsaleVRAppt],

  ]);

  const getImage = (arg) => {
    for (const [keys, image] of imageMap.entries()) {
      if (keys.includes(arg)) return image;
    }
    return null;
  };

  const handleMouseOver = (e) => {
    setImage(getImage(e.target.innerText));
  };

  const featOrNot = (arg) => {
    const SPECIAL_KEYS = ['Featured', 'Bridesmaids'];
    return SPECIAL_KEYS.includes(arg) ? styles.featSubCatContainer : styles.subCategoryContainer;
  };

  return (
    <nav className={`main-nav nav-${klassName}`} role="navigation" aria-label="Top Level Navigation">
      <ul className={klassName} role="menubar">
        {Object.keys(mainMenu).map((key) => {
          if (mainMenu[key].children !== null && mainMenu[key].children?.length > 0) {
            return (
              <li className="list-item" role="menuitem" key={mainMenu[key].name}>
                {mainMenu[key].url || mainMenu[key].url !== '#' ? (
                  <a
                    href={mainMenu[key].url}
                    className={`top-level-link top-level-link--${stringParameterize(mainMenu[key].name)}`}
                    role="button"
                    aria-controls={`submenu-${stringParameterize(mainMenu[key].name)}`}
                    onMouseEnter={handleMouseEnter}
                  >
                    {mainMenu[key].name}
                  </a>
                ) : (
                  <span
                    className={`top-level-link top-level-link--${stringParameterize(mainMenu[key].name)}`}
                    role="button"
                    aria-controls={`submenu-${stringParameterize(mainMenu[key].name)}`}
                    onMouseEnter={handleMouseEnter}
                  >
                    {mainMenu[key].name}
                  </span>
                )}
                <div className={`mega-menu-wrapper mega-menu--${stringParameterize(mainMenu[key].name)}`} id={`submenu-${stringParameterize(mainMenu[key].name)}`}>
                  <div className="page-width inner-menu-wrapper">
                    <ul className="main-submenu" role="menu">
                      {chunkItems(mainMenu[key].children, mainMenu[key].name).map((category) => {
                        if (mainMenu[key].name === 'Shop') {
                          return (
                            <div className={styles.column}>
                              {category.map((item, idx) => (
                                <>
                                  <div>
                                    <li className={styles.categoryContainer} role="none" key={item.name}>
                                      {item.url !== '#' ? (
                                        <a
                                          className={idx === 0 ? styles.categoryLink : featOrNot(item.name)} // Make it so the decoration only applied to first item in category
                                          href={item.url}
                                          role="menuitem"
                                          data-toplevel-link={`top-level-link--${stringParameterize(mainMenu[key].name)}`}
                                          data-linkedto={`mega-menu--${stringParameterize(mainMenu[key].name)}`}
                                        >
                                          {item.name}
                                        </a>
                                      ) : (
                                        <span
                                          className={idx === 0 ? styles.categoryLink : featOrNot(item.name)} // Make it so the decoration only applied to first item in category
                                          role="menuitem"
                                          data-toplevel-link={`top-level-link--${stringParameterize(mainMenu[key].name)}`}
                                          data-linkedto={`mega-menu--${stringParameterize(mainMenu[key].name)}`}
                                        >
                                          {item.name}
                                        </span>
                                      )}
                                    </li>
                                  </div>
                                  {item?.children?.map((subnavLink) => (
                                    <>
                                      <div>
                                        <li onMouseOver={handleMouseOver} role="none" key={subnavLink.name}>
                                          <a
                                            className={subnavLink?.children?.length > 0 ? featOrNot(subnavLink.name) : styles.subnavLink}
                                            href={subnavLink.url}
                                            role="menuitem"
                                          >
                                            {subnavLink.name}
                                          </a>
                                        </li>
                                      </div>
                                      {subnavLink?.children?.length > 0 && subnavLink?.children?.map((lnk) => (
                                        <div>
                                          <li onMouseOver={handleMouseOver} role="none" key={lnk.name}>
                                            <a
                                              className={styles.subnavLink}
                                              href={lnk.url}
                                              role="menuitem"
                                            >
                                              {lnk.name}
                                            </a>
                                          </li>
                                        </div>
                                      ))}
                                    </>
                                  ))}
                                </>
                              ))}
                            </div>
                          );
                        }
                        if (mainMenu[key].name !== 'About') {
                          return (
                            <div>
                              <li onMouseOver={handleMouseOver} role="none" key={category.name}>
                                <a
                                  className={styles.subnavLink}
                                  href={category.url}
                                  role="menuitem"
                                >
                                  {category.name}
                                </a>
                              </li>
                            </div>
                          );
                        }
                      })}
                      {mainMenu[key].name === 'About' && (
                            mainMenu[key].children?.map((aboutNav) => (
                              <div>
                                <li role="none" key={aboutNav.name}>
                                  <a
                                    className={styles.aboutLink}
                                    href={aboutNav.url}
                                    role="menuitem"
                                    data-toplevel-link={`top-level-link--${stringParameterize(mainMenu[key].name)}`}
                                    data-linkedto={`mega-menu--${stringParameterize(mainMenu[key].name)}`}
                                  >
                                    {aboutNav.name}
                                  </a>
                                </li>
                              </div>
                            ))
                      )}

                      {mainMenu[key].name === 'Shop' && (
                        <div className={styles.imageContainer}>
                          <img src={image} alt="menu" className={styles.actualImage} />
                        </div>
                      )}
                    </ul>
                  </div>
                </div>
              </li>
            );
          }

          return (
            <li role="none" className="normal-link" key={mainMenu[key].name}>
              <a href={mainMenu[key].url} role="menuitem">
                {mainMenu[key].name}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default DesktopMainNav;
